<style>
    .c-spinner {
        white-space: nowrap;
        vertical-align: middle;
    }
    .ks-spinner {
        display: inline-block;
    }
    .ks-spinner button {
        color: #333;
        font-weight: 200;
        border: 1px solid #d9d9d9;
        background-color: #fafafa;
        outline: 0;
        height: 30px;
        width: 30px;
        float: left;
    }
    .ks-spinner .ks-form-text {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        height: 30px;
        width: 30px;
        text-align: center;
        float: left;
        margin: 0;
        border-left: none;
        border-right: none;
        outline: 0;
        padding: 0;
    }

    .ks-form-text {
        display: block;
        height: 29px;
        width: 232px;
        padding: 6px 30px 6px 12px;
        float: left;
        font-size: 12px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        outline: 0;
        box-sizing: border-box;
    }
    .c-spinner-disabled  input{
        background-color: #fafafa;
        border-color: #e7e7e7;
        color: #999;
    }
    .ks-spinner button.disabled {
        background-color: #fafafa;
        border-color: #e7e7e7;
        color: #dedede;
    }
</style>

<template>

    <div :class="'c-spinner ks-spinner ' + spinnerClass " :disabled='disabled' :min='min' :max='max'>
        <button type="button" :class='decreaseBtnDisabledClass' @click='_decrease'>-</button>
        <input type="text" :class="'ks-form-text ' + (disabled ? 'c-disabled' : '')" v-model='tem' @change='_change' :disabled='disabled'>
        <button type="button" :class='increaseBtnDisabledClass' @click='_increase'>+</button>
    </div>
</template>

<script>
    export default {
        props: {
            increaseDisabled: Boolean,
            disabled: Boolean,
            min: {
                type: Number,
                default: 1
            },
            max: {
                type: Number,
                default: 30
            },
            value: {
                // type: Number,
                default: 1
            },
            spinnerClass: {
                type: String,
                require: false,
                default: ''
            }
        },

        data() {
            return {
            }
        },
        computed: {
            decreaseBtnDisabledClass() {
                const judge = this.value <= this.min;
                const disable = this.disabled;
                return [
                    (judge || disable) ? ' disabled' : ''
                ];
            },
            increaseBtnDisabledClass() {
                const judge = this.value >= this.max;
                const disable = this.disabled;
                const increaseDisabled = this.increaseDisabled;
                return [
                    (judge || disable || increaseDisabled) ? ' disabled' : ''
                ];
            },
            tem: {
                get() {
                    return this.value;
                }
            }
        },

        watch: {
            spinnerClass() {
                const disable = this.disabled;
                return [
                    disable ? ' c-spinner-disabled' : ''
                ];
            },
            max() {
              var max = this.max;
              if (this.value > max) {
                  this.value = max;
              }
            }
        },

        methods: {
            _increase() {
                if (this.disabled || this.increaseDisabled) {
                    return;
                }
                this._changeValue(this.tem + 1);
            },
            _decrease() {
                if (this.disabled) {
                    return;
                }
                this._changeValue(this.tem - 1);
            },

            _changeValue: function (newVal) {
                const val = this.tem,
                      minV = this.min,
                      maxV = this.max;
                const v = Math.min(maxV, Math.max(minV, newVal));
                // this.$set(this, 'tem', v);
                this.$emit('input', v);
            },

            _change: function (e) {
                var v = e.target.value.trim();
                var reg = /^\d+$/;
                if (!(this.disabled || !reg.test(v))) {
                   this._changeValue(parseInt(v));
                }
                e.target.value = this.tem;
            }
        }
    }
</script>
